/**
 * @file 用户user 模块接口列表
 * @version
 * @author pankzou
 * @date 2021-10-08
 * @lastModified
 * @lastModifiedDate
 */

import { post, postQuery } from "../http"

export default {
    // md5加密
    findDgsLicList(data) {
        return post('/iframework/yDgsLic/findDgsLicList', data)
    },
    // 查询
    licmaininfo(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/licsewpzl', data, { ...headers })
    },
    // 按需查询
    licmaininfobyparam(data, headers) {
        return postQuery('/scjgyzt-public/dataapi/demo/dev/C_ZH/licsewpzlbyparam', data, { ...headers })
    }
}